var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.99995H2.88893M2.88893 4.99995H18M2.88893 4.99995V19C2.88893 19.5304 3.08794 20.039 3.44211 20.4142C3.79639 20.7893 4.27681 21 4.77774 21H14.2223C14.7232 21 15.2036 20.7893 15.5579 20.4142C15.9121 20.039 16.1111 19.5304 16.1111 19V4.99995H2.88893ZM5.72226 4.99995V3.00004C5.72226 2.46952 5.92127 1.96084 6.27544 1.58572C6.62972 1.21072 7.11014 1 7.61107 1H11.3889C11.8899 1 12.3703 1.21072 12.7246 1.58572C13.0787 1.96084 13.2777 2.46952 13.2777 3.00004V4.99995M7.61107 9.99998V16M11.3889 9.99998V16",
    stroke: "#FF3B3B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.47e5a5f779677ccafcecb81ab74e2127.svg";
export { ForwardRef as ReactComponent };